import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/ActionLog/$id')({
    validateSearch: z.object({
        EnterpriseId: z.string().uuid().optional(),
    }),
    beforeLoad: ({ context: { featureFlagService }, params }) => {
        if (featureFlagService.hasFlag(FeatureFlag.newCustomerPageRouteStructureEnabled)) {
            throw redirect({
                to: '/$currentEnterpriseId/Customer/$id/ActionLog',
                params,
            });
        }
    },
    component: BackendPageComponent,
    staticData: {
        routeName: RouteName.CustomerActionLog,
        owner: MewsTeam.Accounts,
        type: RouteType.Backend,
        title: TextKey.ActionLog,
        guideLink: createGuideLink(ArticlePath.ChangeReservationDetails),
    },
});

function BackendPageComponent() {
    const { pathname, search } = Route.useMatch();

    return <BackendPage url={getBackendPageUrl({ pathname, search })} />;
}
